import { observable } from 'mobx';
import { IPicTimeConnectedGallery } from '~/apps/main/PicTime/pic-time.types';

export abstract class BasePicTimeGalleriesStore {
    @observable galleries: IPicTimeConnectedGallery[] = [];
    @observable hasFetchedGalleries = false;
}
